<template>
  <div class="center-item-body">
    <div class="task-tab-body">
      <p class="task-tab" :class="taskType === index ? 'task-tab-active' : ''"
        v-for="(item, index) in typeList" :key="index" @click="selectType(index)">
         {{ item.title }}
        <span class="task-tab-span"></span>
      </p>
    </div>
    <div class="common-task-body">
      <span class="common-task-title" v-show="taskType == 0">新手任务</span>
      <div class="common-task-item-body" v-show="taskType == 0 || taskType == 1">
        <div class="common-task-card" v-for="(item, index) in newHandList" :key="index">
          <div class="common-task-image">
            <img :src="taskList[item.task_id - 1].vsrc"/>
          </div>
          <div class="common-task-data">
            <p class="flex items-center">
              <span class="common-task-name">{{ item.task_name }}</span>
              <img class="common-task-reward-icon" src="../../assets/image/integral_icon_normal.png"/>
              <span class="common-task-reward">+{{ item.task_integral_param }}积分</span>
            </p>
            <p class="common-task-desc">{{ item.task_summary }}</p>
          </div>
          <p class="common-task-get common-task-done-reward" v-if="item.task_complete == 4">已领取</p>
          <p class="common-task-get common-task-get-reward" v-if="item.task_complete == 3"
           @click="getTaskReward(item.task_id,item.task_integral_param)">领取奖励</p>
          <p class="common-task-get common-task-no-reward" v-if="item.task_complete == 2" @click="goTask(item.task_id,item.task_type)">去完成</p>
        </div>
      </div>
      <span class="common-task-title" v-show="taskType == 0">日常任务</span>
      <div class="common-task-item-body" v-show="taskType == 0 || taskType == 2">
        <div class="common-task-card" v-for="(item, index) in dailyList" :key="index">
          <div class="common-task-image">
            <img :src="taskList[item.task_id - 1].vsrc"/>
          </div>
          <div class="common-task-data">
            <p class="flex items-center">
              <span class="common-task-name">{{item.task_name}}</span>
              <img class="common-task-reward-icon" src="../../assets/image/integral_icon_normal.png"/>
              <span class="common-task-reward">+{{ item.task_integral_param }}积分</span>
            </p>
            <p class="common-task-desc">{{ item.task_summary }}</p>
          </div>
          <p class="common-task-get common-task-done-reward" v-if="item.task_complete == 4">已领取</p>
          <p class="common-task-get common-task-get-reward" v-if="item.task_complete == 3"
           @click="getTaskReward(item.task_id,item.task_integral_param)">领取奖励</p>
          <p class="common-task-get common-task-no-reward" v-if="item.task_complete == 2" @click="goTask(item.task_id,item.task_type)">去完成</p>
        </div>
      </div>
      <span class="common-task-title" v-show="taskType == 0">VIP任务</span>
      <div class="common-task-item-body" v-show="taskType == 0 || taskType == 3">
        <div class="common-task-card" v-for="(item, index) in vipList" :key="index">
          <div class="common-task-image">
            <img :src="taskList[item.task_id - 1].vsrc">
          </div>
          <div class="common-task-data">
            <p class="flex items-center">
              <span class="common-task-name">{{item.task_name}}</span>
              <img class="common-task-reward-icon" src="../../assets/image/integral_icon_normal.png"/>
              <span class="common-task-reward">+{{ item.task_integral_param }}积分</span>
            </p>
            <p class="common-task-desc">{{ item.task_summary }}</p>
          </div>
          <p class="common-task-get common-task-done-reward" v-if="item.task_complete == 4">已领取</p>
          <p class="common-task-get common-task-get-reward" v-if="item.task_complete == 3"
           @click="getTaskReward(item.task_id,item.task_integral_param)">领取奖励</p>
          <p class="common-task-get common-task-no-reward" v-if="item.task_complete == 2" @click="goTask(item.task_id,item.task_type)">去完成</p>
        </div>
      </div>
    </div>
  </div>
</template>
 
<script>
  export default {
    computed:{
      baseImageAddress(){
        return this.$store.state.constant.baseImageAddress;
      },
      taskList(){
        return this.$store.state.constant.taskList;
      }
    },
    data() {
      return {
        loginState:false,
        newHandList:[], //新手任务
        dailyList:[], //日常任务
        vipList:[], //vip任务
        taskType:0,
        typeList: [
          { id: "1", title: "全部任务"},
          { id: "2", title: "新手任务"},
          { id: "3", title: "日常任务"},
          { id: "4", title: "VIp任务"}
        ], 
      };
    },
    mounted(){
      if (window.sessionStorage.getItem("token") !== null) {
        this.loginState = true;
      }
    },
    methods:{
      selectType(value) {
        this.taskType = value;
      },
      goTask(value,type){
        if(type == 5){
          this.enterRecharge();
        }else{
          if(value == 5){
            this.enterRecharge();
          }else if(value == 4){
            this.enterRecharge();
          }else if(value == 3){
            this.$router.push({name:"mineCertify"});
          }else if(value == 2){
            this.$router.push({name:"gameCenter"});
          }
        }
      },
      enterRecharge(){
        window.open(this.$router.resolve({name:"recharge"}).href,"_blank");
      },
      queryMineTask(){
        this.$http.post(`/query_web_mine_task`,{})
        .then(res=>{
          if(res.data.code == 2000){
            if(res.data.data.newHand.length > 0){
              this.newHandList = res.data.data.newHand;
            }
            if(res.data.data.daily.length > 0){
              this.dailyList = res.data.data.daily;
            }
            if(res.data.data.vip.length > 0){
              this.vipList = res.data.data.vip;
            }
          }
        })
      },
      getTaskReward(value,integral){
        this.$http.post(`/get_game_task_reward?tid=`+value,{})
        .then(res=>{
          if(res.data.code == 1156){
            this.$emit('childIntegral',integral);
            this.queryMineTask();
          }
          alert(res.data.msg);
        })
      },
      enterTask(){
        window.open(this.$router.resolve({name:"task"}).href,"_blank");
      },
    },
    watch:{
      loginState(value){
        if(value){
          this.queryMineTask();
        }
      }
    } 
  };
</script>
<style src="@/assets/css/mine_center.css" scoped></style>